import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { cicToType, getTimeAgoShort } from "@/helpers/Helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface MemeWinnerArtistInfoProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo?: boolean;
}
export default function MemeWinnerArtistInfo(t0) {
  const $ = _c(30);
  const {
    drop,
    showWaveInfo: t1
  } = t0;
  const showWaveInfo = t1 === undefined ? true : t1;
  const decisionTime = drop.winning_context?.decision_time;
  const t2 = drop.author?.cic;
  let t3;
  if ($[0] !== t2) {
    t3 = cicToType(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const cicType = t3;
  let t4;
  if ($[2] !== drop) {
    t4 = <WaveDropAuthorPfp drop={drop} />;
    $[2] = drop;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== cicType || $[5] !== drop.author) {
    t5 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[4] = cicType;
    $[5] = drop.author;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== drop.author) {
    t6 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold tw-hidden sm:tw-block">{drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><Link onClick={_temp} href={`/${drop.author?.handle}`} className="tw-no-underline desktop-hover:hover:tw-underline tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition tw-duration-300 tw-ease-out">{drop.author?.handle}</Link></UserProfileTooltipWrapper> : <Link onClick={_temp2} href={`/${drop.author?.handle}`} className="tw-no-underline desktop-hover:hover:tw-underline tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition tw-duration-300 tw-ease-out">{drop.author?.handle}</Link>}</p>;
    $[7] = drop.author;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0 tw-hidden sm:tw-block" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== drop.created_at) {
    t8 = getTimeAgoShort(drop.created_at);
    $[10] = drop.created_at;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <p className="tw-text-md tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500">{t8}</p>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = decisionTime ?? null;
  let t11;
  if ($[14] !== t10) {
    t11 = <div className="tw-ml-2"><WinnerDropBadge rank={1} decisionTime={t10} /></div>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t5 || $[18] !== t6 || $[19] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-x-2">{t5}{t6}{t7}{t9}{t11}</div>;
    $[16] = t11;
    $[17] = t5;
    $[18] = t6;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== drop.wave || $[22] !== showWaveInfo) {
    t13 = showWaveInfo && drop.wave && <Link onClick={_temp3} href={`/waves?wave=${drop.wave.id}`} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    $[21] = drop.wave;
    $[22] = showWaveInfo;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t12}{t13}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t14 || $[28] !== t4) {
    t15 = <div className="tw-flex tw-items-center tw-gap-x-3">{t4}{t14}</div>;
    $[27] = t14;
    $[28] = t4;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}